import type { PartialBlock } from '@blocknote/core';

export const FILE_BLOCK_ID_PROP = 'fileId';

const FILE_BLOCK_TYPES = new Set(['image', 'file']);
const FILE_ID_IN_OBJECT_PATH =
  /\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\//i;

function blockProps(block: PartialBlock): Record<string, unknown> {
  return { ...((block.props as Record<string, unknown> | undefined) ?? {}) };
}

export function imageBlockHasFileReference(block: PartialBlock): boolean {
  if (block.type !== 'image' && block.type !== 'file') {
    return false;
  }
  return fileIdFromProps(blockProps(block)) !== null;
}

export function extractFileIdFromObjectUrl(url: string): string | null {
  const match = url.match(FILE_ID_IN_OBJECT_PATH);
  return match?.[1] ?? null;
}

function fileIdFromProps(props: Record<string, unknown>): string | null {
  if (typeof props[FILE_BLOCK_ID_PROP] === 'string' && props[FILE_BLOCK_ID_PROP].length > 0) {
    return props[FILE_BLOCK_ID_PROP];
  }
  if (typeof props.url === 'string') {
    return extractFileIdFromObjectUrl(props.url);
  }
  return null;
}

export function ensureFileIdsInBlocks(blocks: PartialBlock[]): PartialBlock[] {
  function visit(block: PartialBlock): PartialBlock {
    const children = block.children?.map(visit);
    if (!block.type || !FILE_BLOCK_TYPES.has(block.type)) {
      return children ? { ...block, children } : block;
    }

    const props = blockProps(block);
    const fileId = fileIdFromProps(props);
    if (fileId) {
      props[FILE_BLOCK_ID_PROP] = fileId;
    }

    return { ...block, props, children };
  }

  return blocks.map(visit);
}

export function stripFileUrlsForStorage(blocks: PartialBlock[]): PartialBlock[] {
  function visit(block: PartialBlock): PartialBlock {
    const children = block.children?.map(visit);
    if (!block.type || !FILE_BLOCK_TYPES.has(block.type)) {
      return children ? { ...block, children } : block;
    }

    const props = blockProps(block);
    const fileId = fileIdFromProps(props);
    if (fileId) {
      props[FILE_BLOCK_ID_PROP] = fileId;
      delete props.url;
    }

    return { ...block, props, children };
  }

  return blocks.map(visit);
}
